import { Helmet } from 'react-helmet'
import {PhoneLink} from '../../components/Shared/Links'

export default function Pairing(){
  return (
    <div className="pageStyles pairing">
      <Helmet>
        <title></title>
        <meta name="description" content="Every month, Villaggio Grille hosts a wine dinner showcasing a different vineyard. With the amazing dishes they create to accompany each wine, every dinner becomes a four-course experience that your taste buds will thank you for." />
      </Helmet>

      <div className="events-listing-page custStylePTA">
        <div id="page-title" className="pt-bkg-image image-events">
          <div className="overlay">
            <div className="container">
              <div className="row">
                <div className="title-container less">
                  <h1>All Rosé in May</h1>
                  <h4 className="one">
                    May 15th &nbsp;&middot;&nbsp; 6pm 
                    <span className="rules"> &nbsp;&middot;&nbsp; </span>
                    <br className="rules" />
                    $60 per guest
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-content">
          <div className="container food-menus no-padding">
            <div className="intro">
              <p className="res">For Reservations: <span><PhoneLink /></span></p>
            </div>
            <div className="clearfix"></div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>
            
            <div className="course">
              <div className="service-box-2">
                <h3>Course One</h3>
                <h4>Prosciutto Wrapped Stuffed Jumbo Gulf Shrimp</h4>
                <h5>Stuffed Formaggio Fresco Montana, Focaccia Bread Crumbs, Romesco Sauce</h5>
                <p>Paired with</p>
                <h4>Casal Garcia, Vinho Verde Rosé, Portugal</h4>
              </div>
            </div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>

            <div className="course">
              <div className="service-box-2">
                <h3>Course Two</h3>
                <h4>Spring Radicchio Salad</h4>
                <h5>Dyno Kale, Garbanzo Beans, Soft Boiled Egg, Goat Cheese Croquette, Dressed with Stone Ground Honey Mustard Vinaigrette</h5>
                <p>Paired with</p>
                <h4>El Coto de Rioja, Rioja Rosado, Spain</h4>
              </div>
            </div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>

            <div className="course">
              <div className="service-box-2">
                <h3>Course Three</h3>
                <h4>Citrus Grilled Salmon</h4>
                <h5>Meyer Lemon Parmesan Orzo, Heirloom Cherry Tomatoes, Sunflower Arugula Pesto</h5>
                <p>Paired with</p>
                <h4>Erath, Pinot Noir Rosé, Oregon</h4>
              </div>
            </div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>

            <div className="course">
              <div className="service-box-2">
                <h3>Course Four</h3>
                <h4>Strawberry Cream Cheese Crumb Cake</h4>
                <h5>Topped with Strawberry Caviar Pearls</h5>
                <p>Paired with</p>
                <h4>Graham Beck, Brut Rosé Methode Cap Classique, South Africa</h4>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-xs-12"><div className="hr hr-png-1"></div></div>
    </div>
  )
}
